import { render, staticRenderFns } from "./LightColumn.vue?vue&type=template&id=4fd394d9&scoped=true"
import script from "./LightColumn.vue?vue&type=script&lang=js"
export * from "./LightColumn.vue?vue&type=script&lang=js"
import style0 from "./LightColumn.vue?vue&type=style&index=0&id=4fd394d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd394d9",
  null
  
)

export default component.exports